import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'

type ContainerLogResult = RestSchemas['Services.Support.ContainerLogResult']

export const containerLogsColumns: ColumnDef<ContainerLogResult>[] = [
  {
    id: 'timeGenerated',
    accessorKey: 'timeGenerated',
    header: ({ column }) => <SortingHeaderButton column={column}>Time</SortingHeaderButton>,
    cell: ({ cell }) => {
      const value = cell.getValue() as string | undefined
      const d = value ? new Date(value) : null
      return <span className="text-xs text-muted-foreground">{d ? d.toLocaleString() : ''}</span>
    },
    sortingFn: (rowA, rowB) => {
      const a = rowA.original.timeGenerated ? new Date(rowA.original.timeGenerated).getTime() : 0
      const b = rowB.original.timeGenerated ? new Date(rowB.original.timeGenerated).getTime() : 0
      return a - b
    },
    size: 140,
  },
  {
    id: 'logMessage',
    accessorKey: 'logMessage',
    header: () => <span>Log Message</span>,
    cell: ({ cell }) => <span className="text-xs">{(cell.getValue() as string) || ''}</span>,
    enableSorting: false,
    size: 1000,
  },
]
